import { useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { Input } from "@/components/ui/input";

const card = "bg-white rounded-[16px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100";
const btn = "h-8 px-3 rounded-lg border border-slate-200 text-sm font-semibold hover:bg-slate-50 disabled:opacity-40";
const AUD = { cliente: "proprietários e compradores", consultor: "consultores" };

function SidRow({ t, value, placeholder, onSave, testid }) {
  const [v, setV] = useState(value || "");
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Input value={v} onChange={(e) => setV(e.target.value)} placeholder={placeholder} className="h-8 w-[22rem] max-w-full font-mono text-xs" data-testid={`${testid}-input`} />
      <button onClick={() => onSave(v.trim() || null)} disabled={(v.trim() || "") === (value || "")} className={btn} data-testid={`${testid}-save`}>Guardar</button>
      {value && <button onClick={() => { setV(""); onSave(null); }} className="text-xs text-slate-500 underline" data-testid={`${testid}-clear`}>remover</button>}
    </div>
  );
}

function TestSend({ t }) {
  const [to, setTo] = useState("");
  const send = async () => {
    try { const { data } = await api.post("/platform/wa-templates/test", { name: t.name, to }); toast.success(`Enviado (${data.status})`); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  if (!t.sid) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 mt-1.5">
      <Input value={to} onChange={(e) => setTo(e.target.value)} placeholder="+351 912 345 678" className="h-8 w-44" data-testid={`admin-wat-test-to-${t.name}`} />
      <button onClick={send} disabled={!to.trim()} className={btn} data-testid={`admin-wat-test-${t.name}`}>Enviar teste</button>
      <span className="text-xs text-slate-500">com valores fictícios</span>
    </div>
  );
}

export function WaTemplates({ data, setData }) {
  const save = async (name, sid) => {
    try { setData((await api.put("/platform/wa-templates", { name, sid })).data); toast.success(sid ? "Content SID guardado" : "Content SID removido"); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  return (
    <div className={card} data-testid="admin-wa-templates">
      <h3 className="font-heading text-lg text-ec-green">Modelos de WhatsApp (Twilio)</h3>
      <p className="text-sm text-slate-500 mt-1 max-w-2xl">Content SIDs dos modelos aprovados na conta de WhatsApp do ImoDesk. Servem todas as agências. Sem SID, o modelo não é usado. Se faltar algum valor numa mensagem, não é enviada e fica registado no histórico do processo.</p>
      <ul className="mt-3 divide-y divide-slate-100">{data.wa_templates.map((t) => (
        <li key={t.name} className="py-3" data-testid={`admin-wat-${t.name}`}>
          <div className="flex flex-wrap items-baseline gap-2">
            <span className="font-mono text-sm font-semibold text-slate-800">{t.name}</span>
            <span className="text-xs text-slate-500">para {AUD[t.audience]}{t.button ? ` · botão «${t.button}»` : ""}</span>
            <span className={`text-[11px] font-semibold rounded-full px-2 py-0.5 ${t.sid ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-500"}`} data-testid={`admin-wat-state-${t.name}`}>{t.sid ? "com SID" : "sem SID"}</span>
          </div>
          <p className="text-xs text-slate-500 mt-1 max-w-2xl">{t.body}</p>
          <p className="text-xs text-slate-400 mt-0.5">{t.vars.map((v, i) => `{{${i + 1}}} ${v}`).join(" · ")}</p>
          <div className="mt-2"><SidRow t={t} value={t.sid} placeholder="HX…" onSave={(sid) => save(t.name, sid)} testid={`admin-wat-sid-${t.name}`} /></div>
          <TestSend t={t} />
        </li>))}</ul>
    </div>
  );
}

export function AgencyWaOverrides({ a, data, setData }) {
  const [open, setOpen] = useState(Object.keys(a.wa_templates_override || {}).length > 0);
  const save = async (name, sid) => {
    try { setData((await api.put(`/platform/agencies/${a.id}/wa-templates`, { name, sid })).data); toast.success(sid ? "SID próprio guardado" : "Volta ao SID global"); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  return (
    <div className="border-t border-slate-100 pt-3" data-testid={`admin-wat-agency-${a.id}`}>
      <button onClick={() => setOpen(!open)} className="text-sm font-medium text-slate-700" data-testid={`admin-wat-agency-toggle-${a.id}`}>
        Modelos de WhatsApp próprios (opcional){Object.keys(a.wa_templates_override || {}).length ? ` · ${Object.keys(a.wa_templates_override).length} substituído(s)` : ""}
      </button>
      {open && <div className="mt-2 space-y-2">{data.wa_templates.map((t) => (
        <div key={t.name} className="flex flex-wrap items-center gap-2 text-sm">
          <span className="font-mono text-xs w-48 text-slate-700">{t.name}</span>
          <SidRow t={t} value={(a.wa_templates_override || {})[t.name]} placeholder={t.sid ? `global: ${t.sid}` : "HX… (sem SID global)"} onSave={(sid) => save(t.name, sid)} testid={`admin-wat-own-${a.id}-${t.name}`} />
        </div>))}</div>}
    </div>
  );
}
